(function () {

  window._awControlledVariantIds = window._awControlledVariantIds || new Set();

  function loadMap() {
    const el = document.querySelector('[data-payment-control-variants]');
    if (!el) return;
    try {
      const map = JSON.parse(el.textContent || '{}');
      Object.keys(map).forEach(function (id) {
        if (map[id] === true) window._awControlledVariantIds.add(String(id));
      });
    } catch (e) {}
  }

  function checkVariant(variantId) {
    return window._awControlledVariantIds.has(String(variantId));
  }

  async function updatePaymentControl(isControlled) {
    // カートの_controlled_idsを確認して最終判断
    const cart = await fetch('/cart.js').then(function (r) { return r.json(); });
    let controlledIds = [];
    try {
      controlledIds = JSON.parse(cart.attributes['_controlled_ids'] || '[]');
    } catch (e) { controlledIds = []; }

    const cartVariantIds = (cart.items || []).map(function (i) { return String(i.variant_id); });
    const activeControlled = controlledIds.filter(function (id) {
      return cartVariantIds.includes(String(id));
    });
    const finalControlled = isControlled || activeControlled.length > 0;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { '_payment_control': finalControlled ? 'true' : '' }
      })
    });
  }

  function initPaymentControl() {
    if (!window.FoxTheme?.pubsub) {
      setTimeout(initPaymentControl, 200);
      return;
    }

    loadMap();

    const form = document.querySelector('form[action*="/cart/add"]');
    const variantInput = form && form.querySelector('[name="id"]');
    if (variantInput && variantInput.value) {
      updatePaymentControl(checkVariant(variantInput.value));
    }

    FoxTheme.pubsub.subscribe('variant-change', function (data) {
      try {
        const variant = data?.data?.variant;
        if (!variant) return;
        updatePaymentControl(checkVariant(variant.id));
      } catch (e) {}
    });
  }

  document.addEventListener('DOMContentLoaded', initPaymentControl);

})();
